import OnePrintManifestContainer from "../containers/OnePrintManifestContainer";

const OnePrintManifestPage = () => {
    return <OnePrintManifestContainer />;
};

export default OnePrintManifestPage;
